xw
<template>
  <div class="home">
    <v-row>
      <v-col>
        <v-card class="mx-auto" max-width="344">
          <v-card-text>
            <div>Daily Leads</div>
            <p class="display-1 text--primary">
              {{ leadCount }}
            </p>
          </v-card-text>
          <v-card-actions>
            <v-btn
              text
              color="green accent-4"
              @click="$router.push({ path: 'leads' })"
            >
              Weitere Leads anzeigen
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from '../lib/api';

export default {
  name: 'Home',
  data() {
    return {
      leadCount: 0,
    };
  },
  mounted() {
    this.$store.dispatch('fetchDisabledLeads');
    this.$store.dispatch('fetchAllLeads');
    this.getDailyLeads();
  },
  methods: {
    getDailyLeads() {
      const t = this;
      axios.get('/data/daily').then((res) => {
        t.leadCount = res.data.count;
      });
    },
  },
};
</script>
